module.exports = __webpack_public_path__ + "img/positivo_2.dfaea230.svg";